// eslint-disable-next-line no-redeclare,no-unused-vars
function register(element, object, id, key) {
    if (!elements[object]) elements[object] = {};
    if (!elements[object][id]) elements[object][id] = {};
    if (!elements[object][id][key + '_els']) elements[object][id][key + '_els'] = [];
    // $.each(elements[object][id][key+'_els'],function(i,el){ if (el && !$.contains(document.body,el[0])) delete elements[object][id][key+'_els'][i]; }); -> bug if element is not added to dom
    elements[object][id][key + '_els'].push(element);
}

//# sourceMappingURL=index.9f225be4.js.map
